/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export interface FirstLandModalProps {
  openFreeTrialFirstLandModal: (props: any) => void;
  isDirectMailReturningUser: boolean;
  isDirectMailUser: boolean;
  onboardingTrialSource: string;
  showMobileInterstitialModal: boolean;
  handleMobile: () => void;
}

const FirstLandModal = ({
  openFreeTrialFirstLandModal,
  isDirectMailReturningUser,
  isDirectMailUser,
  onboardingTrialSource,
  showMobileInterstitialModal,
  handleMobile,
  ...restProps
}: FirstLandModalProps) => {
  useEffect(() => {
    if (showMobileInterstitialModal) {
      handleMobile();
    }
  }, [showMobileInterstitialModal, handleMobile]);

  useEffect(() => {
    if (!showMobileInterstitialModal) {
      openFreeTrialFirstLandModal({
        ...restProps,
        isDirectMailReturningUser,
        isDirectMailUser,
        onboardingTrialSource,
      });
    }
  }, [
    showMobileInterstitialModal,
    isDirectMailReturningUser,
    isDirectMailUser,
    openFreeTrialFirstLandModal,
    restProps,
    onboardingTrialSource,
  ]);

  return null;
};

export default FirstLandModal;
